import { Serializer } from 'src/app/core/common/http/serializer';
import { AreaFusionResource, UserOfAfTypeResource } from './areafusion.resource';
import { AreaFusionModel } from '../model/area-fusion.model';

export class AreaFusionSerializer implements Serializer {
  fromJson(json: any): AreaFusionResource {
    const resource = new AreaFusionResource();
    resource.type_user = new UserOfAfTypeResource();
    resource.type_user.id = json.type_user.id;
    resource.type_user.type = json.type_user.type;
    resource.url = json.url;
    resource.buyer = json.buyer;
    resource.requester = json.requester;
    resource.approver = json.approver;
    resource.approval_power = json.approval_power;
    resource.approval_power_cost_centers = json.approval_power_cost_centers;
    resource.notes = json.notes;


    if (resource.type_user.id == "RPSF") {
      resource.society = json.society;
      resource.user_profile = json.user_profile;
      resource.belonging_offices = json.belonging_offices;
      resource.url = "";
    }


    return resource;
  }

  toJson(model: AreaFusionModel): any {
    const resource = new AreaFusionResource();
    resource.type_user = new UserOfAfTypeResource();
    resource.type_user.id = model.type_user[0].id;
    resource.type_user.type = model.type_user[0].type;
    resource.url = model.url;
    resource.approval_power = model.approval_power;
    resource.approval_power_cost_centers = model.approval_power_cost_centers;
    resource.notes = model.notes;


    if (resource.type_user.id == "RPSF") {

      resource.url = "";

      resource.society = "";
      if (model.society.length > 0) {
        let tmp_society = [];
        model.society.forEach((c) => {
          tmp_society.push(c.value);
        });
        resource.society = tmp_society.join(",");
      }

      resource.user_profile = "";
      if(model.user_profile.length > 0){
        resource.user_profile = model.user_profile[0].value;
      }

      resource.belonging_offices = "";
      if(model.belonging_offices.length > 0){
        resource.belonging_offices = model.belonging_offices[0].value;
      }

    }



    return resource;
  }
}